import { render } from "./ProfitCard.vue?vue&type=template&id=636d9a54&scoped=true"
import script from "./ProfitCard.vue?vue&type=script&lang=js"
export * from "./ProfitCard.vue?vue&type=script&lang=js"

import "./ProfitCard.vue?vue&type=style&index=0&id=636d9a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636d9a54"]])

export default __exports__